import { createUniqueCustomProperties } from '../../../utils/createUniqueCustomProperty.es.js';

const Vars = createUniqueCustomProperties("Table", [
  "frozenCellHorzShadowOpacity",
  "frozenCellVertShadowOpacity"
]);

export { Vars };
//# sourceMappingURL=Vars.es.js.map
